/** */
export const isEmailValid = (email) => {
  const pattern =
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return pattern.test(email);
};

export const isPasswordValid = (password) => {
  return password.length >= 8;
};

/** Free/public email providers that are not allowed for work-email signups. */
export const PUBLIC_EMAIL_DOMAINS = [
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'yahoo.co.uk',
  'ymail.com',
  'hotmail.com',
  'hotmail.co.uk',
  'outlook.com',
  'live.com',
  'msn.com',
  'aol.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'protonmail.com',
  'proton.me',
  'gmx.com',
  'zoho.com',
  'mail.com',
  'yandex.com'
];

/** True when the email uses a private/work domain (not a free public provider). */
export const isWorkEmail = (email) => {
  if (!isEmailValid(email)) return false;
  const domain = email.split('@').pop().toLowerCase();
  return !PUBLIC_EMAIL_DOMAINS.includes(domain);
};
